import { Logo } from '@/assets/logo';
import { Button } from '@/components/ui/button';

interface NavbarProps {
  onMenuClick: () => void;
}

export function Navbar({ onMenuClick }: NavbarProps) {
  return (
    <nav className="h-16 bg-white shadow-sm">
      <div className="max-w-7xl mx-auto px-4 h-full flex items-center">
        {/* Left side - Menu button */}
        <div className="w-10 lg:hidden">
          <Button
            variant="ghost"
            size="icon"
            onClick={onMenuClick}
          >
            <svg className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
            </svg>
          </Button>
        </div>

        {/* Center - Logo and titles */}
        <div className="flex-1 flex items-center justify-center gap-4">
          <span className="text-xl font-semibold text-primary-dark">
            الخدمات الإلكترونية
          </span>
          <Logo className="h-14" />
          <span className="text-xl font-semibold text-primary-dark">
            eService
          </span>
        </div>

        {/* Right side - Empty space for symmetry */}
        <div className="w-10" />
      </div>
    </nav>
  );
}